<app-company-info
  [companyInitials]="companyInitials"
  [company]="company"
></app-company-info>
<mat-card
  ><mat-card-content>
    <div class="header-wrapper">
      <div class="header-wrapper-left-button">
        <button aria-label="collapse" mat-button="" (click)="_location.back()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div>
          <span class="mat-h2">{{ header }}</span>
        </div>
      </div>
      <div class="header-wrapper-right-button">
        <div>
          <button
            mat-stroked-button
            color="primary"
            aria-label="plus"
            mat-button=""
            (click)="handleAddClick()"
            [matTooltip]="'Add_branch_to_user' | translate"
          >
            <mat-icon>add</mat-icon>
            <span>{{ 'USER_BRANCHES_DIALOG.add_branches_title'| translate }}</span>
          </button>
        </div>
        <div [matTooltip]="isAllSelected() 
            ? ('Remove_All_Branch_Assignments' | translate) 
            : (this.selection.hasValue() 
                ? ('Remove_branch_from_user' | translate) 
                : ('Remove_Branch_Disabled' | translate))" >
          <button
            mat-stroked-button
            color="primary"
            aria-label="trash"
            mat-button=""
            (click)="removeBranches()"          
            [disabled]="!this.selection.hasValue() || isAllSelected()"
          >
            <mat-icon>delete_outline</mat-icon>
            <span>{{'COMPANY_DELETE_USERS.delete_users_company_confirmation' | translate}}</span>
          </button>
        </div>
        <div>
          <mat-form-field floatLabel="always" appearance="outline" >
            <mat-label class="mat-label">{{
              'SEARCH.search' | translate
            }}</mat-label>
            <input
              id="search"
              #search
              matInput
              (keyup)="monitorSearch(search.value)"
              [placeholder]="'COMPANY_BRANCHES.searchPlaceholder' | translate"
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>
    @if (noRecordFound) {
    <app-not-found
      [displayMessage]="message"
    ></app-not-found>
    }

    <table
      mat-table
      [dataSource]="branchesDataSource"
      [ngClass]="noRecordFound ? 'hide' : ''"
    >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <div [matTooltip]="currentPageBranches?.length === 1 ? ('Remove_All_Branch_Assignments' | translate)  : ''">          
          <mat-checkbox
            color="primary"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="isPartiallySelected()"
            [disabled]="branchesDataSource === undefined || currentPageBranches?.length == 1"
          >
          </mat-checkbox>
          </div>
        </th>
        <td mat-cell class="border" *matCellDef="let row">
          <div [matTooltip]="currentPageBranches?.length === 1 ? ('Remove_All_Branch_Assignments' | translate)  : ''">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"            
            [disabled]="currentPageBranches?.length == 1"
          >
          </mat-checkbox>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef width="40%">
          {{ 'COMPANY_BRANCHES.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let branch">
          {{ branch.name }}
          @if (!branch.parentAccountId) {
          <mat-chip>{{
            'COMPANY_BRANCHES.headQuarters' | translate
          }}</mat-chip>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPANY_BRANCHES.address' | translate }}
        </th>
        <td mat-cell *matCellDef="let branch">{{ branch.address }}</td>
      </ng-container>

      <ng-container matColumnDef="sectorNumber">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPANY_BRANCHES.sectorNumber' | translate }}
        </th>
        <td mat-cell *matCellDef="let branch">{{ branch.sectorNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPANY_BRANCHES.location' | translate }}
        </th>
        <td mat-cell *matCellDef="let branch">{{ branch.location }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
    @if (!noRecordFound) {
    <mat-paginator
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[10, 25, 50, 100]"
    ></mat-paginator>
    }
  </mat-card-content>
</mat-card>
@if (_changeBranchesService.loading) {
<app-spinner></app-spinner>
}
